// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/mutation-copy.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_Content_Content_Procedure($objects: [vaxiom_procedures_insert_input!]!) {
  insert_vaxiom_procedures(objects: $objects) {
    affected_rows
  }
}

`